import { useEffect } from "react";
import type { FC } from "react";
import { Hub } from "aws-amplify/utils";
import { trackAuthEvent, setUserProperties } from "../utils/analyticsService";

const AuthAnalyticsTracker: FC = () => {
  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload }) => {
      try {
        switch (payload.event) {
          case "signedIn":
            trackAuthEvent("sign_in");

            // Set user properties if available
            if (payload.data) {
              setUserProperties({
                user_id: payload.data.userId || payload.data.username,
              });
            }

            console.log("📊 Auth event tracked: sign_in");
            break;

          case "signedOut":
            trackAuthEvent("sign_out");
            console.log("📊 Auth event tracked: sign_out");
            break;

          default:
            // Handle auth errors and other events
            if (
              payload.event.includes("failure") ||
              payload.event.includes("error")
            ) {
              console.log("📊 Auth event tracked: error -", payload.event);
            } else if (
              payload.event.includes("signUp") ||
              payload.event.includes("signup")
            ) {
              trackAuthEvent("sign_up");
              console.log("📊 Auth event tracked: sign_up");
            }
            break;
        }
      } catch (error) {
        console.error("❌ Error tracking auth event:", error);
      }
    });

    return unsubscribe;
  }, []);

  return null;
};

export default AuthAnalyticsTracker;
